var _jsxFileName = "/repo/packages/webassets/src/components/Header/wrench/components/info-menu/NotificationsSheet.tsx",
  _this = this;
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState } from 'react';
import { merge } from 'lodash';
import { MetricsTracker, USER_EVENTS } from '@sm/metrics';
import { t, defineMessages } from '@sm/intl';
import { Button } from '@wds/button';
import { Box } from '@wds/box';
import { Link } from '@wds/link';
import { Sheet } from '@wds/sheet';
import { Typography } from '@wds/typography';
import { SkeletonLoader, InfiniteScrollTrigger } from '@sm/webassets';
import { useInProductMessagesQuery } from './InProductMessages.generated';
import { useMarkAllMessagesAsReadMutation } from './MarkAllMessagesAsRead.generated';
import useStyles from './useStyles';
import NotificationItem from './NotificationItem';
import notificationZeroStateImage from '../../../static/images/notification-zero-state.svg';
var PAGE_SIZE = 10;
export var COPY = defineMessages({
  NOTIFICATION_CENTER: {
    id: 'NotificationsSheet.notificationCenter',
    defaultMessage: 'Notification center',
    description: '[Type: Label][Vis.: high] - This is the title of the notification center.'
  },
  NO_NOTIFICATIONS_IMG: {
    id: 'NotificationsSheet.noNotificationsImg',
    defaultMessage: 'Graphic of a notifications interface',
    description: '[Type: Label][Vis.: high] - This is an image depicting the notifications interface.'
  },
  NO_NOTIFICATIONS_TITLE: {
    id: 'NotificationsSheet.noNotificationsTitle',
    defaultMessage: 'Watch the bell for updates',
    description: '[Type: Label][Vis.: high] - This is the title displayed when there are no notifications.'
  },
  NO_NOTIFICATIONS_BODY: {
    id: 'NotificationsSheet.noNotificationsBody',
    defaultMessage: "We'll notify you about new activity on your surveys or account.",
    description: '[Type: Label][Vis.: high] - This is the message displayed when there are no notifications'
  },
  LEARN: {
    id: 'NotificationsSheet.learn',
    defaultMessage: 'Learn more',
    description: '[Type: Label][Vis.: high] - This is the text for a "Learn more" cta link.'
  },
  MARK_ALL: {
    id: 'NotificationsSheet.markAll',
    defaultMessage: 'Mark all as read',
    description: '[Type: Label][Vis.: high] - This is the label for the "Mark all as read" action button.'
  },
  MARK_ALL_ERROR: {
    id: 'NotificationsSheet.markAllError',
    defaultMessage: 'There was an error marking all notifications as read.',
    description: '[Type: Label][Vis.: high] - This is the error message displayed when there is an issue with marking all notifications as read.'
  },
  END_OF_NOTIFICATIONS: {
    id: 'NotificationsSheet.endOfNotifications',
    defaultMessage: 'These are all your notifications from the last 30 days.',
    description: '[Type: Label][Vis.: high] - This is the message indicating the end of the list of notifications.'
  },
  NOTIFICATIONS_ERROR: {
    id: 'NotificationsSheet.notificationsError',
    defaultMessage: 'An error occured while loading your notifications.',
    description: '[Type: Label][Vis.: high] - This is the error message displayed when there is an issue with loading notifications.'
  },
  SHARE: {
    id: 'NotificationsSheet.share',
    defaultMessage: 'Share feedback',
    description: '[Type: Label][Vis.: high] - This is the text for a "Share feedback" cta link thhat brings up a survey.'
  }
});
var NotificationSkeletonLoader = function NotificationSkeletonLoader() {
  return /*#__PURE__*/React.createElement(Box, {
    m: 5,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 88,
      columnNumber: 3
    }
  }, /*#__PURE__*/React.createElement(SkeletonLoader, {
    height: 100,
    width: "100%",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 89,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("path", {
    x: "16",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 5C0 2.23858 2.23858 0 5 0H81C83.7614 0 86 2.23858 86 5C86 7.76142 83.7614 10 81 10H5C2.23858 10 0 7.76142 0 5Z",
    fill: "#E5E6EA",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 90,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement("path", {
    x: "16",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 26C0 23.2386 2.23858 21 5 21H282C284.761 21 287 23.2386 287 26C287 28.7614 284.761 31 282 31H5C2.23858 31 0 28.7614 0 26Z",
    fill: "#B7B8BC",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 97,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement("path", {
    x: "16",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 47C0 44.2386 2.23858 42 5 42H144C146.761 42 149 44.2386 149 47C149 49.7614 146.761 52 144 52H5C2.23858 52 0 49.7614 0 47Z",
    fill: "#C1C3C9",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 104,
      columnNumber: 7
    }
  })), /*#__PURE__*/React.createElement(SkeletonLoader, {
    height: 100,
    width: "100%",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 112,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("path", {
    x: "16",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 5C0 2.23858 2.23858 0 5 0H81C83.7614 0 86 2.23858 86 5C86 7.76142 83.7614 10 81 10H5C2.23858 10 0 7.76142 0 5Z",
    fill: "#E5E6EA",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 113,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement("path", {
    x: "16",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 26C0 23.2386 2.23858 21 5 21H282C284.761 21 287 23.2386 287 26C287 28.7614 284.761 31 282 31H5C2.23858 31 0 28.7614 0 26Z",
    fill: "#B7B8BC",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 120,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement("path", {
    x: "16",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 47C0 44.2386 2.23858 42 5 42H144C146.761 42 149 44.2386 149 47C149 49.7614 146.761 52 144 52H5C2.23858 52 0 49.7614 0 47Z",
    fill: "#C1C3C9",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 127,
      columnNumber: 7
    }
  })), /*#__PURE__*/React.createElement(SkeletonLoader, {
    height: 100,
    width: "100%",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 135,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("path", {
    x: "16",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 5C0 2.23858 2.23858 0 5 0H81C83.7614 0 86 2.23858 86 5C86 7.76142 83.7614 10 81 10H5C2.23858 10 0 7.76142 0 5Z",
    fill: "#E5E6EA",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 136,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement("path", {
    x: "16",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 26C0 23.2386 2.23858 21 5 21H282C284.761 21 287 23.2386 287 26C287 28.7614 284.761 31 282 31H5C2.23858 31 0 28.7614 0 26Z",
    fill: "#B7B8BC",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 143,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement("path", {
    x: "16",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 47C0 44.2386 2.23858 42 5 42H144C146.761 42 149 44.2386 149 47C149 49.7614 146.761 52 144 52H5C2.23858 52 0 49.7614 0 47Z",
    fill: "#C1C3C9",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 150,
      columnNumber: 7
    }
  })));
};
var NotificationsSheet = function NotificationsSheet(_ref) {
  var _data$inProductMessag, _data$inProductMessag2, _notificationsContent;
  var showNotifications = _ref.showNotifications,
    toggleNotifications = _ref.toggleNotifications,
    unreadNotificationsCount = _ref.unreadNotificationsCount,
    pageName = _ref.pageName,
    pageURL = _ref.pageURL,
    userId = _ref.userId,
    packageId = _ref.packageId,
    refetchNotificationIconCount = _ref.refetchNotificationIconCount,
    lang = _ref.lang;
  var _useStyles = useStyles(),
    notificationsContainer = _useStyles.notificationsContainer,
    notificationsList = _useStyles.notificationsList,
    notificationsEmpty = _useStyles.notificationsEmpty;
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    hasMoreToLoad = _useState2[0],
    setHasMoreToLoad = _useState2[1];
  var trackNotificationsEvent = function trackNotificationsEvent(interactionLocation, userTotalMessages) {
    MetricsTracker.track({
      name: USER_EVENTS.ELEMENT_INTERACTION,
      data: {
        amplitudeEvent: 'notification center interaction',
        interactionType: 'click',
        interactionLocation: interactionLocation,
        messageCountTotal: userTotalMessages,
        messageCountUnread: unreadNotificationsCount,
        pageName: pageName,
        pageURL: pageURL
      }
    });
  };
  var _useInProductMessages = useInProductMessagesQuery({
      variables: {
        input: {
          isDeleted: false,
          beforeMessageId: null,
          pageSize: PAGE_SIZE
        }
      },
      skip: !showNotifications,
      fetchPolicy: 'network-only'
    }),
    loading = _useInProductMessages.loading,
    error = _useInProductMessages.error,
    data = _useInProductMessages.data,
    refetchMessages = _useInProductMessages.refetch,
    fetchMoreMessages = _useInProductMessages.fetchMore;
  var successfullyMarkedAllAsRead = function successfullyMarkedAllAsRead() {
    refetchMessages();
    refetchNotificationIconCount();
  };
  var _useMarkAllMessagesAs = useMarkAllMessagesAsReadMutation({
      onCompleted: successfullyMarkedAllAsRead
    }),
    _useMarkAllMessagesAs2 = _slicedToArray(_useMarkAllMessagesAs, 2),
    markAllMessagesAsRead = _useMarkAllMessagesAs2[0],
    _useMarkAllMessagesAs3 = _useMarkAllMessagesAs2[1],
    loadingMarkAll = _useMarkAllMessagesAs3.loading,
    errorMarkAll = _useMarkAllMessagesAs3.error;
  var notificationsContent = data === null || data === void 0 ? void 0 : (_data$inProductMessag = data.inProductMessages) === null || _data$inProductMessag === void 0 ? void 0 : _data$inProductMessag.items;
  var notificationsLastMessageId = data === null || data === void 0 ? void 0 : (_data$inProductMessag2 = data.inProductMessages) === null || _data$inProductMessag2 === void 0 ? void 0 : _data$inProductMessag2.cursorInfo.lastMessageId;
  var userHasNoMessages = (notificationsContent === null || notificationsContent === void 0 ? void 0 : notificationsContent.length) === 0;
  var userTotalMessages = notificationsContent === null || notificationsContent === void 0 ? void 0 : notificationsContent.length;
  var showMarkAllAsRead = (notificationsContent === null || notificationsContent === void 0 ? void 0 : notificationsContent.some(function (message) {
    return message.isRead === false;
  })) || unreadNotificationsCount > 0;
  var clickMarkAllAsRead = function clickMarkAllAsRead() {
    markAllMessagesAsRead({
      variables: {
        input: {
          notAfterDate: notAfterDate
        }
      }
    });
    trackNotificationsEvent('mark all as read', userTotalMessages);
  };
  var updateMessages = function updateMessages(prevData, _ref2) {
    var newData = _ref2.fetchMoreResult;
    if (!newData) {
      return prevData;
    }
    if ((newData === null || newData === void 0 ? void 0 : newData.inProductMessages.items.length) < PAGE_SIZE) {
      setHasMoreToLoad(false);
    } else {
      setHasMoreToLoad(true);
    }
    var combinedData = merge({}, prevData, newData, {
      inProductMessages: {
        items: prevData.inProductMessages.items.concat(newData.inProductMessages.items)
      }
    });
    return combinedData;
  };
  var onLoadMore = function onLoadMore() {
    fetchMoreMessages({
      variables: {
        input: {
          beforeMessageId: notificationsLastMessageId,
          pageSize: PAGE_SIZE,
          isDeleted: false
        }
      },
      updateQuery: updateMessages
    });
  };
  var onClickFeedback = function onClickFeedback(e) {
    trackNotificationsEvent('share feedback', userTotalMessages);
  };
  var notAfterDate = notificationsContent && ((_notificationsContent = notificationsContent[0]) === null || _notificationsContent === void 0 ? void 0 : _notificationsContent.sentAt);
  var closeSheet = function closeSheet() {
    setHasMoreToLoad(true);
    toggleNotifications();
  };
  return /*#__PURE__*/React.createElement(Sheet, {
    show: showNotifications,
    onClose: closeSheet,
    showCloseButton: true,
    offsetTop: 48,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 308,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(Sheet.Header, {
    header: t(COPY.NOTIFICATION_CENTER),
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 314,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(Sheet.Body, {
    padding: false,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 315,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Box, {
    className: notificationsContainer,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 316,
      columnNumber: 9
    }
  }, userHasNoMessages ? /*#__PURE__*/React.createElement(Box, {
    mx: 6,
    my: 10,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 319,
      columnNumber: 15
    }
  }, /*#__PURE__*/React.createElement(Box, {
    className: notificationsEmpty,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 320,
      columnNumber: 17
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: notificationZeroStateImage,
    alt: t(COPY.NO_NOTIFICATIONS_IMG),
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 321,
      columnNumber: 19
    }
  })), /*#__PURE__*/React.createElement(Typography, {
    variant: "body",
    align: "center",
    component: "p",
    color: "dark",
    weight: "medium",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 326,
      columnNumber: 17
    }
  }, t(COPY.NO_NOTIFICATIONS_TITLE)), /*#__PURE__*/React.createElement(Typography, {
    variant: "bodySm",
    align: "center",
    component: "p",
    color: "darkMuted",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 335,
      columnNumber: 17
    }
  }, t(COPY.NO_NOTIFICATIONS_BODY), ' ', /*#__PURE__*/React.createElement(Link, {
    underline: true,
    href: "https://help.surveymonkey.com/".concat(lang, "/surveymonkey/send/survey-notifications/"),
    target: "_blank",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 342,
      columnNumber: 19
    }
  }, t(COPY.LEARN)))) : !!data && !userHasNoMessages ? [showMarkAllAsRead && /*#__PURE__*/React.createElement(Box, {
    m: 2,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 354,
      columnNumber: 17
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    align: "right",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 355,
      columnNumber: 19
    }
  }, /*#__PURE__*/React.createElement(Button, {
    size: "sm",
    color: "muted",
    onClick: clickMarkAllAsRead,
    loading: loadingMarkAll,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 356,
      columnNumber: 21
    }
  }, t(COPY.MARK_ALL))), errorMarkAll && /*#__PURE__*/React.createElement(Box, {
    mx: 6,
    my: 6,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 366,
      columnNumber: 21
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "bodySm",
    align: "center",
    component: "p",
    color: "darkMuted",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 367,
      columnNumber: 23
    }
  }, t(COPY.MARK_ALL_ERROR)))), /*#__PURE__*/React.createElement("ul", {
    className: notificationsList,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 379,
      columnNumber: 15
    },
    key: "1"
  }, notificationsContent === null || notificationsContent === void 0 ? void 0 : notificationsContent.map(function (notification) {
    return /*#__PURE__*/React.createElement(NotificationItem, {
      key: "notification-id-".concat(notification.id),
      id: notification.id,
      sentAt: notification.sentAt,
      read: notification.isRead,
      campaignName: notification.campaignName,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 381,
        columnNumber: 19
      }
    }, notification.content);
  })), !hasMoreToLoad && /*#__PURE__*/React.createElement(Box, {
    mx: 8,
    my: 10,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 393,
      columnNumber: 17
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "bodySm",
    align: "center",
    component: "p",
    color: "darkMuted",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 394,
      columnNumber: 19
    }
  }, t(COPY.END_OF_NOTIFICATIONS))), /*#__PURE__*/React.createElement(InfiniteScrollTrigger, {
    hasMoreToLoad: hasMoreToLoad,
    onLoadMore: onLoadMore,
    loadingFirstData: loading,
    loadingMore: loading,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 404,
      columnNumber: 15
    },
    key: "3"
  }), hasMoreToLoad && /*#__PURE__*/React.createElement(NotificationSkeletonLoader, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 410,
      columnNumber: 33
    }
  })] : !!loading ? /*#__PURE__*/React.createElement(NotificationSkeletonLoader, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 413,
      columnNumber: 15
    }
  }) : !!error ? /*#__PURE__*/React.createElement(Box, {
    my: 10,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 416,
      columnNumber: 15
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "bodySm",
    align: "center",
    component: "p",
    color: "darkMuted",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 417,
      columnNumber: 17
    }
  }, t(COPY.NOTIFICATIONS_ERROR))) : null)), !userHasNoMessages && /*#__PURE__*/React.createElement(Sheet.Footer, {
    align: "left",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 431,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(Link, {
    underline: true,
    href: "#",
    onClick: function onClick(e) {
      onClickFeedback(e);
      window.open("https://www.surveymonkey.com/r/5H7LWPQ?yuuzXf=%5B".concat(userId, "%5D&piDCatBf=%5B").concat(packageId, "%5D"), '_blank');
      return false;
    },
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 432,
      columnNumber: 11
    }
  }, t(COPY.SHARE))));
};
export default NotificationsSheet;
export { NotificationsSheet };
//# sourceMappingURL=NotificationsSheet.js.map